import { render, staticRenderFns } from "./AboutLine.vue?vue&type=template&id=5ffa5c38&scoped=true&"
import script from "./AboutLine.vue?vue&type=script&lang=js&"
export * from "./AboutLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa5c38",
  null
  
)

export default component.exports